import React, { useState, useEffect } from "react";
import { AddSlabIcon } from "../../../utility/constants/assetsManager";
import {
  colorBlack,
  colorLightGrey,
  colorWhite,
  primaryColor,
  secondaryColor,
} from "../../../utility/constants/colorManager";
import {
  PERCENTAGE,
  RUPEES,
  RUPEES_SYMBOL,
} from "../../../utility/constants/valueConstants";
import { CustomButton } from "../main_comps/custom_button";
import { CustomInput } from "../main_comps/custom_input/CustomInput";
import "./index.css";
import SlabContainerComp from "./SlabContainerComp";
import "../../../scrollStyles.css";
import { useSnackbar } from "notistack";
import { current } from "@reduxjs/toolkit";

export const Divider = ({ style }) => {
  return (
    <div
      style={{
        backgroundColor: "#D9D9D9",
        height: 80,
        width: 1,
        ...style,
      }}
    ></div>
  );
};
const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled = false,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        disabled={disabled}
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        checked={defaultChecked}
        style={{
          margin: "0px 10px",
        }}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

const FlatContainer = ({
  onChange,
  type,
  rate,
  disabled = false,
  isEditClicked,
  clientRateEmpty,
}) => {
  const [amount, setAmount] = useState("");
  const [value, setValue] = useState(RUPEES);

  const onChangeValues = (amount, value) => {
    onChange(amount, value);
  };

  useEffect(() => {
    if (rate?.length > 0) {
      setAmount(rate[0]?.value);
      setValue(rate[0]?.type);
    }
  }, [rate]);

  useEffect(() => {
    if (!isEditClicked && rate?.length > 0) {
      setAmount(rate[0]?.value);
      setValue(rate[0]?.type);
    }
  }, [!isEditClicked, rate]);

  useEffect(() => {
    if (clientRateEmpty) {
      setAmount("");
    }
  }, [clientRateEmpty]);

  useEffect(() => {
    if (isEditClicked) {
      setAmount("");
    }
  }, [isEditClicked]);

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
      }}
    >
      <CustomInput
        disabled={disabled}
        type="select"
        options={[
          {
            label: `${RUPEES_SYMBOL}`,
            value: RUPEES,
          },
          {
            label: `%`,
            value: PERCENTAGE,
          },
        ]}
        value={value}
        inputStyles={{
          width: 70,
          minWidth: 0,
          border: "1px solid #CBCBCB",
        }}
        containerStyles={{
          width: 70,
          border: "1px solid #CBCBCB",
        }}
        onChange={(val) => {
          setValue(val);
          onChangeValues(amount, val);
        }}
      />
      <CustomInput
        disabled={disabled}
        value={amount}
        onChange={(data) => {
          setAmount(data);
          onChangeValues(data, value);
        }}
        inputcomponentStyles={{ ...styles.inputStyle }}
        placeholder=""
        validator={value === RUPEES ? "paise" : "percentageDecimal"}
        type="input"
        inputStyles={{
          ...styles.containerStyle,
        }}
      />
    </div>
  );
};

const FlatContainertwo = ({ onChange, disabled = false, Amount, Value }) => {
  const [amount, setAmount] = useState(Amount);
  const [value, setValue] = useState(Value);

  const onChangeValues = (amount, value) => {
    onChange(amount, value);
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 20,
      }}
    >
      <CustomInput
        disabled={disabled}
        type="select"
        options={[
          {
            label: `${RUPEES_SYMBOL}`,
            value: RUPEES,
          },
          {
            label: `%`,
            value: PERCENTAGE,
          },
        ]}
        value={value}
        inputStyles={{
          width: 70,
          minWidth: 0,
          border: "1px solid #CBCBCB",
        }}
        containerStyles={{
          width: 70,
          border: "1px solid #CBCBCB",
        }}
        onChange={(val) => {
          setValue(val);
          onChangeValues(amount, val);
        }}
      />
      <CustomInput
        disabled={disabled}
        value={amount}
        onChange={(data) => {
          setAmount(data);
          onChangeValues(data, value);
        }}
        inputcomponentStyles={{ ...styles.inputStyle }}
        placeholder=""
        validator={value === RUPEES ? "paise" : "percentageDecimal"}
        type="input"
        inputStyles={{
          ...styles.containerStyle,
        }}
      />
    </div>
  );
};

const SlabContainer = ({
  onChangeTexts,
  isValuesAdded,
  disabled = false,
  isEditClicked,
  initialValues,
}) => {
  const [from, setFrom] = useState(initialValues.from || "");
  const [to, setTo] = useState(initialValues.to || "");

  const [amount, setAmount] = useState(initialValues.amount || "");
  const [value, setValue] = useState(initialValues.type || RUPEES);

  const onChangeValues = (amount, value, from, to) => {
    onChangeTexts(amount, value, from, to);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #CBCBCB",
        borderRadius: 5,
        padding: "10px",
        boxSizing: "border-box",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 0.55,
          rowGap: 20,
        }}
      >
        <div>
          <p>From</p>
          <CustomInput
            disabled={disabled}
            value={from}
            onChange={(data) => {
              setFrom(data);
              onChangeValues(amount, value, data, to);
            }}
            inputcomponentStyles={{ ...styles.inputStyle }}
            placeholder=""
            validator="number"
            type="input"
            inputStyles={{
              ...styles.containerStyle,
            }}
          />
        </div>
        <div>
          <p>To</p>
          <CustomInput
            disabled={disabled}
            value={to}
            onChange={(data) => {
              setTo(data);
              onChangeValues(amount, value, from, data);
            }}
            inputcomponentStyles={{ ...styles.inputStyle }}
            placeholder=""
            validator="number"
            type="input"
            inputStyles={{
              ...styles.containerStyle,
            }}
          />
        </div>
      </div>
      <Divider
        style={{
          display: "flex",
          margin: "0px 10px",
        }}
      />
      <div
        style={{
          display: "flex",
          flex: 0.4,
          padding: "0px 10px",
        }}
      >
        <FlatContainertwo
          disabled={disabled}
          onChange={(amount, val) => {
            setAmount(amount);
            onChangeValues(amount, val, from, to);
            setValue(val);
          }}
          Amount={amount}
          Value={value}
        />
      </div>
    </div>
  );
};

export const checkObjHasAllValue = (obj) => {
  if (Object.keys(obj).length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).every((val) => {
      return obj[val] !== "" && obj[val] !== undefined;
    });
    return val;
  }
};

export const checkAnyOneObjHasAllValue = (obj) => {
  if (Object.keys(obj).length === 0) {
    return false;
  } else {
    let val = Object.keys(obj).some((val) => {
      return obj[val] !== "";
    });
    return val;
  }
};

function CommissionContainerPrefill({
  onClickNext,
  onClickBack,
  isSlabRequired = false,
  styles,
  innerStyles,
  rate,
  type,
  ex,
  disabled = false,
  isEditClicked,
  amount,
  clientRateEmpty,
  setServiceProviderType,
  isFlatRequired = true,
}) {
  const [currentValue, setCurrentValue] = useState("");
  const [totalCommission, setTotalCommission] = useState([]);
  const [flatComission, setFlatComission] = useState({});
  const [comissionObj, setComissionObj] = useState({});
  const [isValuesAdded, setIsValuesAdded] = useState(false);
  const [currentObject, setCurrentObject] = useState({});
  const [showSlabArray, setShowSlabArray] = useState([<SlabContainer />]);
  const [slabRates, setSlabRates] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!isFlatRequired) {
      setCurrentValue("slab");
    } else {
      setCurrentValue("flat");
    }
  }, []);

  useEffect(() => {
    if (checkObjHasAllValue(currentObject))
      onClickNext(
        [...totalCommission, ...slabRates, currentObject],
        {},
        currentValue
      );
  }, [currentObject, currentValue]);
  // useEffect(() => {
  //   if (checkObjHasAllValue(currentObject))
  //     onClickNext(currentObject, {}, currentValue);
  // }, [currentObject, currentValue]);

  useEffect(() => {
    onClickNext([...totalCommission], flatComission, currentValue);
  }, [flatComission, currentValue]);

  // useEffect(() => {
  //   if (currentValue === "flat") {
  //     setTotalCommission([]);
  //   } else {
  //     setFlatComission({});
  //   }
  // }, [currentValue]);

  // useEffect(() => {
  //
  // }, [rate, totalCommission, flatComission]);

  useEffect(() => {
    if (type && type?.toLowerCase() === "flat") {
      setCurrentValue("flat");
      setFlatComission(rate[0]);
    } else if (type && type?.toLowerCase() === "slab") {
      setCurrentValue("slab");
      setTotalCommission(rate);
    }
  }, [type]);

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: colorLightGrey,
        boxSizing: "border-box",
        padding: 10,
        ...styles,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "15px 0px",
          ...innerStyles,
        }}
      >
        <div
          style={{
            flex: 0.55,
            display: "flex",
          }}
        >
          {isFlatRequired && (
            <RadioButton
              disabled={disabled}
              id="flat"
              name={"flat_radio" + ex}
              title="Flat"
              value="flat"
              onChange={(val) => {
                setCurrentValue(val.target.value);
              }}
              defaultChecked={currentValue === "flat"}
            />
          )}{" "}
          {isSlabRequired && (
            <RadioButton
              disabled={disabled}
              id="slab"
              name={"flat_radio" + ex}
              title="Slab"
              value="slab"
              onChange={(val) => {
                setCurrentValue(val.target.value);
              }}
              defaultChecked={currentValue === "slab"}
              style={{
                margin: "0px 10px",
              }}
            />
          )}
        </div>

        {currentValue === "flat" && isFlatRequired && (
          <Divider
            style={{
              display: "flex",
              height: 40,
              margin: "0px 10px",
            }}
          />
        )}
        {currentValue === "flat" && isFlatRequired && (
          <div
            style={{
              display: "flex",
            }}
          >
            <FlatContainer
              disabled={disabled}
              onChange={(amount, val) => {
                setFlatComission({
                  value: amount,
                  type: val ? val : "RUPEES",
                  from: null,
                  to: null,
                });
              }}
              rate={rate}
              isEditClicked={isEditClicked}
              clientRateEmpty={clientRateEmpty}
            />
          </div>
        )}
      </div>
      {currentValue === "slab" && (
        <div
          style={{
            width: "100%",
            backgroundColor: colorWhite,
            maxHeight: 300,
            overflow: "auto",
          }}
        >
          {totalCommission &&
            !isEditClicked &&
            totalCommission.map((data, i) => (
              <SlabContainerComp
                from={data.from}
                to={data.to}
                value={data.value}
                type={data.type}
                id={i}
                isEditClicked={isEditClicked}
                onClickDelete={(id) => {
                  const filteredData = totalCommission.filter(
                    (val, i) => i !== id
                  );
                  setTotalCommission([...filteredData]);
                }}
              />
            ))}

          {isEditClicked && totalCommission.length > 0 && (
            <div>
              {totalCommission.map((commission, index) => (
                <SlabContainer
                  key={index}
                  isValuesAdded={isValuesAdded}
                  initialValues={{
                    amount: commission.value,
                    from: commission.from,
                    to: commission.to,
                    type: commission.type,
                  }}
                  onChangeTexts={(amount, val, from, to) => {
                    if (
                      checkObjHasAllValue({
                        value: amount,
                        type: val,
                        from,
                        to,
                      })
                    ) {
                      // setCurrentObject({
                      //   value: amount,
                      //   type: val,
                      //   from,
                      //   to,
                      // });
                      let newArr = totalCommission;

                      newArr.map((obj, i) => {
                        if (obj._id === commission._id) {
                          newArr[i] = {
                            value: amount,
                            type: val,
                            from,
                            to,
                            _id: obj._id,
                          };
                        }
                      });

                      setTotalCommission(newArr);
                    }
                  }}
                />
              ))}
            </div>
          )}
          {isEditClicked && totalCommission.length === 0 && (
            <div>
              {showSlabArray.map((index) => (
                <div key={index}>
                  <SlabContainer
                    isValuesAdded={isValuesAdded}
                    onChangeTexts={(amount, val, from, to) => {
                      if (
                        checkObjHasAllValue({
                          value: amount,
                          type: val,
                          from,
                          to,
                        })
                      ) {
                        setCurrentObject({
                          value: amount,
                          type: val,
                          from,
                          to,
                        });
                      }
                    }}
                    initialValues={{}}
                  />
                </div>
              ))}

              <div
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  margin: "10px 0px",
                  width: "auto",
                }}
                onClick={() => {
                  if (checkObjHasAllValue(currentObject)) {
                    setShowSlabArray([...showSlabArray, <SlabContainer />]);
                    setSlabRates([...slabRates, currentObject]);
                    setCurrentObject({});
                  } else {
                    enqueueSnackbar("Please enter all the fields", {
                      variant: "error",
                    });
                  }
                }}
              >
                <AddSlabIcon
                  style={{
                    marginRight: 15,
                  }}
                />
                <p
                  style={{
                    color: secondaryColor,
                    fontSize: 13,
                  }}
                >
                  Add More Slab
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  inputStyle: {
    alignSelf: "center",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
    width: "100%",
  },
  containerStyle: {
    padding: 0,
    height: 50,
    width: 60,
    height: 40,
    margin: 0,
    backgroundColor: colorWhite,
    border: "1px solid #CBCBCB",
  },
};
export default CommissionContainerPrefill;
